export const FETCH_ISLAND_GROUP_URL = `${process.env.REACT_APP_API_URL}/island_groups`;
export const CREATE_ISLAND_GROUP_URL = `${process.env.REACT_APP_API_URL}/island_groups/create`;
export const UPDATE_ISLAND_GROUP_URL = `${process.env.REACT_APP_API_URL}/island_groups`;
export const DELETE_ISLAND_GROUP_URL = `${process.env.REACT_APP_API_URL}/island_groups`;
